/* Runspire (v28): na pagina de produto, cria o espaco do prazo de entrega logo abaixo dos botoes de compra (o runspire-custom.js preenche, com o frete gratis como subtitulo). Roda antes do runspire-custom.js. */
(function () {
  var info = document.querySelector('.product__info-container');
  if (!info) return;
  var pf = info.querySelector('product-form');
  if (pf && !document.querySelector('.rs-frete-slot')) {
    var s = document.createElement('div');
    s.className = 'rs-frete-slot';
    pf.insertAdjacentElement('afterend', s);
  }
})();
